import sortBy from 'lodash/sortBy';

import { GetActivitiesSections_getActivitiesSections_components_ActivitiesMultipleChoiceComponent_properties_multipleChoice } from 'approot/activity-builder/__generated__/GetActivitiesSections';
import { FILL } from '../image/image-crop.constants';
import {
  MultipleChoiceCropData,
  MultipleChoiceOption,
  MultipleChoiceProperties,
} from './multiple-choice.constants';
import {
  ACTIVITIES_ANSWER_MODE_FREE,
  ACTIVITIES_RESPONSE_VARIANT_IMAGE,
  ACTIVITIES_RESPONSE_VARIANT_TEXT,
  ACTIVITIES_RESPONSE_VARIANT_TEXT_IMAGE,
  COMPONENT_LAYOUT_LIST,
} from 'global/constants';

export function canShowOptionLetter(showOptionLetter: boolean | null) {
  return showOptionLetter === null || showOptionLetter;
}

export function isImageLayoutFill(imageLayout: string | null) {
  return imageLayout === null || imageLayout === FILL;
}

export function getImageCropData(
  imageLayout: string | null,
  cropData: MultipleChoiceCropData | null
) {
  return isImageLayoutFill(imageLayout) && cropData === null
    ? {
        x: 0.5,
        y: 0.5,
        width: 0,
        height: 0,
        naturalHeight: 0,
        naturalWidth: 0,
        zoom: 1,
      }
    : cropData;
}

export function getDefaultRowAndGridLayout(numberOfOptions: number) {
  switch (numberOfOptions) {
    case 2:
      return '1x2';
    case 3:
      return '1x3';
    case 4:
      return '1x4';
    case 5:
      return '1x5';
    case 6:
      return '1x6';
    default:
      return '2x1';
  }
}

export function getRowAndColumnsValue(rowsGridLayout: string) {
  const parts = rowsGridLayout.split('x');
  return {
    rows: Number(parts[0]),
    columns: Number(parts[1]),
  };
}

export function getOptionsPerColumn(
  multipleChoice: GetActivitiesSections_getActivitiesSections_components_ActivitiesMultipleChoiceComponent_properties_multipleChoice
) {
  const layout =
    multipleChoice.rowsGridLayout ||
    getDefaultRowAndGridLayout(multipleChoice.options.length);
  const layoutData = getRowAndColumnsValue(layout);
  return layoutData.columns;
}

export function parseMultipleChoiceTypes(properties: MultipleChoiceProperties) {
  return {
    isList: properties.layout?.display === COMPONENT_LAYOUT_LIST,
    isText:
      properties.multipleChoice.variant === ACTIVITIES_RESPONSE_VARIANT_TEXT,
    isImage:
      properties.multipleChoice.variant === ACTIVITIES_RESPONSE_VARIANT_IMAGE,
    isTextAndImage:
      properties.multipleChoice.variant ===
      ACTIVITIES_RESPONSE_VARIANT_TEXT_IMAGE,
    isFree:
      properties.multipleChoice.answerMode === ACTIVITIES_ANSWER_MODE_FREE,
    isRevealAnswer: properties.multipleChoice.revealAnswer,
  };
}

export function sortOptions(options: MultipleChoiceOption[]) {
  return sortBy(options, 'sort');
}
